module.exports = __webpack_public_path__ + "media/images/college-park-flat-color-2508023a.png";